import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { setActiveUser } from 'redux/actions/tabs'
import { reinitializeCampaignData } from 'redux/actions/marketing'
import moduleActions from 'redux/modules/actions'
import { MnemonicsBadge } from 'components/mnemonics'
import MainMenuUI from './MainMenuUI'
import Grafana from 'services/Grafana'
import TabTitle from 'services/TabTitle'
import { getTrialDaysLeft } from 'utils/helpers'
import { getMenuLevelFromURL } from './utils'

const tabTitle = new TabTitle()

const MainMenu = ({ isOpen }) => {
  const { user, companies, sidebar, mnemonics, poolLists } = useSelector(store => store)
  const dispatch = useDispatch()
  const { push } = useHistory()
  const { pathname } = useLocation()
  const [menuLevelsOpened, setMenuLevelsOpened] = useState({})
  const [isOverlay, setIsOverlay] = useState(false)
  const freeTrialDays = getTrialDaysLeft(companies.trialAt)

  useEffect(() => {
    const menuValue = getMenuLevelFromURL(pathname)
    if (menuValue) setMenuLevelsOpened({ [`level${menuValue.level}`]: menuValue.menuName })
  }, [])

  const openGrafana = ({ module, url }) => {
    dispatch(moduleActions.add(module, false))
      .then(data => {
        if (data?.result?.[module]?.isActive) {
          Grafana.openTab(url, companies._id, { locale: user?.locale })
        }
      })
  }

  const getPoolsMnemonicsCount = useMemo(() => {
    const totalMainPool = mnemonics.totalMainPool || 0
    const totalAssigned = mnemonics.totalAssigned || 0

    const total = totalMainPool + totalAssigned

    tabTitle.addMNemonics(total)

    return total
  }, [mnemonics.totalMainPool,  mnemonics.totalAssigned])

  const getMnemonics = (itemName) => {
    if (itemName === 'nav_conversations_title') return <MnemonicsBadge customBadgeColor='light' isSidebar value={getPoolsMnemonicsCount} />
    if (itemName === 'nav_conversations_users') return <MnemonicsBadge location='poolMain' isSidebar showRealNumber />
    if (itemName === 'nav_conversations_assignations') return <MnemonicsBadge location='poolAssigned' isSidebar showRealNumber />
    if (itemName === 'nav_conversations_lists') return <MnemonicsBadge location='poolLists' isSidebar showRealNumber value={poolLists.listWithUsers} />
  }

  const handleMenuItem = ({ menuId, menuLevel, url, type, module }) => {
    if (type === 'grafana') return openGrafana({ module, url })

    // Si es menú
    if (menuId) {
      // Si el menú está abierto lo cierra
      if (menuLevelsOpened[`level${menuLevel}`] === menuId) {
        return setMenuLevelsOpened(prevState => ({ ...prevState, [`level${menuLevel}`]: '' }))
      }

      // Si el menú es de primer nivel lo abre y limpia el resto de niveles
      if (menuLevel === 1) setMenuLevelsOpened({ level1: menuId })

      // Si el menú es de segundo nivel en adelante lo actualiza
      return setMenuLevelsOpened(prevState => ({ ...prevState, [`level${menuLevel}`]: menuId }))
    }

    // Si no es menú redirige a la URL
    if (menuLevel === 1 && Object.keys(menuLevelsOpened).length) {
      setMenuLevelsOpened({})
    }

    if (url === '/dashboard/conversations/search') dispatch(setActiveUser(null))
    if (url === '/dashboard/marketing/create/campaigns') dispatch(reinitializeCampaignData())

    if (url.includes('http')) {
      window.open(url, '_blank', 'noopener, noreferrer')
    } else {
      push(url)
    }
  }

  return (
    <MainMenuUI
      isOpen={isOpen}
      user={user}
      company={companies}
      sidebar={sidebar}
      poolLists={poolLists}
      menuLevelsOpened={menuLevelsOpened}
      pathname={pathname}
      freeTrialDays={freeTrialDays}
      isOverlay={isOverlay}
      setIsOverlay={setIsOverlay}
      getMnemonics={getMnemonics}
      handleMenuItem={handleMenuItem}
    />
  )

}

export default MainMenu
